/* Da Vinci Cine-Novel Viewer 2.0 Styles */
@import url('https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&family=Noto+Sans+KR:wght@300;400;500;700&display=swap');

:root {
    /* Cine-Novel Palette */
    --dv-bg: #121212;
    --dv-text-primary: #e0e0e0;
    --dv-text-secondary: #a0a0a0;
    --dv-accent: #818cf8;
    /* Indigo-400 */

    /* Dynamic Variables (Controlled by JS) */
    --dv-font-size: 1.2rem;
    --dv-line-height: 1.8;
    --dv-font-family: 'Nanum Myeongjo', serif;
}

/* Root Scoping to prevent leaks */
.davinci-viewer-root {
    width: 100%;
    min-height: 100vh;
    background-color: var(--dv-bg);
    color: var(--dv-text-primary);
    font-family: var(--dv-font-family);
    position: relative;
    overflow-x: hidden;
    /* Prevent horizontal scroll from effects */
    -webkit-font-smoothing: antialiased;
}

/* =========================================
   Layers
   ========================================= */
.dv-layer-atmosphere {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    transition: background-color 2s ease, opacity 2s ease;
    /* Ambient Light Source */
    background: radial-gradient(circle at 50% 30%, rgba(0, 0, 0, 0) 0%, var(--dv-bg) 80%);
}

.dv-layer-content {
    position: relative;
    z-index: 10;
    max-width: 768px;
    /* Standard Logic */
    margin: 0 auto;
    padding: 0 0 200px 0;
    /* Footer Space */
}

/* =========================================
   Typography & Blocks
   ========================================= */
.dv-block {
    margin-bottom: 2rem;
    opacity: 0;
    /* Default invisible */
    transform: translateY(20px);
    transition: opacity 1s cubic-bezier(0.2, 0.8, 0.2, 1), transform 1s cubic-bezier(0.2, 0.8, 0.2, 1);
    will-change: opacity, transform;
}

.dv-block.visible {
    opacity: 1;
    transform: translateY(0);
}

.dv-text-container {
    padding: 0 1.5rem;
    font-size: var(--dv-font-size);
    line-height: var(--dv-line-height);
    color: var(--dv-text-primary);
    text-align: justify;
    word-break: keep-all;
    white-space: pre-wrap;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.dv-paragraph {
    margin-bottom: 0.8rem;
    /* Paragraph spacing */
    min-height: 1rem;
}

.dv-paragraph.type-dialogue {
    margin-left: 0.5rem;
    padding-left: 1rem;
    border-left: 3px solid var(--dv-accent);
    /* Changed to Accent Color */
    color: var(--dv-text-primary);
    font-weight: 700;
}

.dv-image-wrapper {
    position: relative;
    width: 100%;
    margin: 3rem 0;
    overflow: hidden;
    line-height: 0;
}

.dv-image {
    width: 100%;
    height: auto;
    display: block;
    transform: scale(1.05);
    /* Slight Zoom for Ken Burns */
    transition: transform 3s ease-out;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.dv-block.visible .dv-image {
    transform: scale(1);
}

/* Mobile Bleed */
@media (max-width: 768px) {
    .dv-image-wrapper {
        margin: 2rem 0;
        box-shadow: none;
    }
}

/* =========================================
   Security
   ========================================= */
.dv-secure-guard {
    position: absolute;
    inset: 0;
    z-index: 50;
    /* Transparent overlay to block Right Click/Save As on Image */
}

/* =========================================
   UI Components
   ========================================= */
.dv-copyright {
    text-align: center;
    padding: 40px 20px;
    font-family: sans-serif;
    font-size: 0.75rem;
    color: #555;
    border-bottom: 1px solid #222;
    background: linear-gradient(to bottom, #1a1a1a, var(--dv-bg));
    margin-bottom: 60px;
}

.dv-copyright strong {
    color: #e53935;
    display: block;
    margin-bottom: 4px;
    font-size: 0.9rem;
}

/* Navigation Footer */
.dv-nav-footer {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 40px 20px;
    margin-top: 60px;
    border-top: 1px solid #222;
}

.dv-nav-btn {
    flex: 1;
    padding: 16px;
    border-radius: 12px;
    background: #1f1f1f;
    border: 1px solid #333;
    color: #aaa;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    font-family: sans-serif;
}

.dv-nav-btn:hover:not(:disabled) {
    background: #333;
    color: white;
    border-color: #555;
}

.dv-nav-btn.primary {
    background: var(--dv-accent);
    color: #000;
    border-color: transparent;
}

.dv-nav-btn.primary:hover {
    filter: brightness(1.1);
}

.dv-nav-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

/* Animation Utilities */
.fade-up {
    animation: fadeInUp 1s ease forwards;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}